import React from 'react';

const productsData = [
    {
        id: 1,
        title: "Glodesk",
        desc: "Smarter coworking and facility management that makes your workspace run smoothly, stay organized, and feel effortless to manage every day.",
        image: "/assets/transforming/img5.png"
    },
    {
        id: 2,
        title: "Glokode",
        desc: "Make your work easier by simplifying processes, automating routine tasks, and helping your team make better decisions with less effort and more clarity.",
        image: "/assets/transforming/img6.png"
    }
];

const OurProductsSection = () => {
    return (
        <section className="w-full bg-[#FFFFFF] py-16 sm:py-20 lg:py-24 overflow-hidden select-none text-left">
            <div className="max-w-[1440px] w-full mx-auto px-5 sm:px-10 lg:px-[80px]">

                <div className="w-full mb-12 lg:mb-16">
                    <h2 className="text-[#0A2540] font-sora font-[600] lg:text-[30px] text-[20px] leading-[1.2] tracking-tight">
                        Our Products
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 w-full">
                    {productsData.map((product) => (
                        <div
                            key={product.id}
                            className="group relative w-full flex flex-col justify-start transition-all duration-500"
                        >
                            <div className="relative w-full h-[353px] overflow-hidden">
                                <img
                                    src={product.image}
                                    alt={product.title}
                                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                />
                            </div>

                            <div className="relative w-[90%] sm:w-[85%] bg-white p-6 sm:p-8 mt-[-64px] mx-auto z-10 text-left overflow-hidden shadow-[0_15px_30px_rgba(10,37,64,0.08)] transition-colors duration-300">
                                <h3 className="text-[#0A2540] font-sora text-[16px] sm:text-[20px] font-[600] tracking-tight leading-snug mb-4 duration-300">
                                    {product.title}
                                </h3>
                                <p className="text-[#4A5568] font-graphik text-[14px] sm:text-[16px] leading-relaxed font-[500] opacity-90 group-hover:opacity-100 transition-opacity duration-300 mb-1">
                                    {product.desc}
                                </p>

                                <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]" />

                                <div
                                    className="absolute bottom-0 left-0 h-[4px] w-0 bg-[#ED7A3A] group-hover:w-full transition-all duration-500 ease-out z-20"
                                />
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default OurProductsSection;